import { useAuthStore } from "@/store/auth.store";
import { minutesToMilliseconds } from "date-fns";
import { useEffect } from "react";
import { useShallow } from "zustand/shallow";

// every 10 minutes refresh the token
const POLLING_INTERVAL = minutesToMilliseconds(10);

/// poll refresh token and set the local storage
export const usePollRefreshToken = () => {
  const refreshToken = useAuthStore(useShallow((state) => state.refreshToken));

  useEffect(() => {
    refreshToken();

    const interval = setInterval(() => {
      refreshToken();
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [refreshToken]);
};

export default usePollRefreshToken;
